import { ApplicationState } from '../../../../store/types';
import { getDropdownListRoot } from '../../store/selectors';
import { DropdownList, DropdownListDB } from './types';

export const getModalOpen = (state: ApplicationState): boolean => getDropdownListRoot(state).modalOpen;

export const getPreviewModalOpen = (state: ApplicationState): boolean => getDropdownListRoot(state).previewModalOpen;

export const getDropdownList = (state: ApplicationState): DropdownList => getDropdownListRoot(state).dropdownList;

export const getAllDropdownLists = (state: ApplicationState): DropdownListDB[] => getDropdownListRoot(state).publishedDropdownLists;

export const getIsSaving = (state: ApplicationState): boolean => getDropdownListRoot(state).isSaving;
